<template>
  <v-stepper class="elevation-0" v-model="cStep" style="border: 1px solid dodgerblue">
    <v-stepper-header>
      <template v-for="(item, key) in steps">
        <v-stepper-step
          :key="`${key}-step`"
          :complete="cStep > key + 1 || cStep === 5"
          :step="key + 1"
          :color="cStep > key + 1 || cStep === 5 ? 'success' : 'primary'"
        >
          {{ item.judul }}
        </v-stepper-step>

        <v-divider v-if="key + 1 !== steps.length" :key="key" />
      </template>
    </v-stepper-header>
  </v-stepper>
</template>

<script>
export default {
  name: 'Stepper',
  props: {
    currStep: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      steps: [
        { judul: 'Verval Data', step: 1 },
        { judul: 'Seleksi Peserta', step: 2 },
        { judul: 'Penetapan Sebaran', step: 4 },
        { judul: 'Berita Acara', step: 8 },
        { judul: 'Selesai', step: 10 },
      ],
    };
  },

  computed: {
    cStep() {
      const mapStep = {
        1: 1,
        2: 2,
        4: 3,
        5: 3,
        6: 4,
        7: 4,
        8: 4,
        9: 4,
        10: 5,
      };

      return mapStep[this.currStep];
    },
  },
};
</script>

<style scoped></style>
